import type { UploadingDescriptor } from 'reactApp/modules/uploading/serviceClasses/UploadingDescriptor';
import { ERetryErrorFileOptions } from 'reactApp/modules/uploading/uploading.types';
import { EFileError, EFileStatus } from 'reactApp/modules/uploadList/uploadList.model';
import { updateUploadFilesAction } from 'reactApp/modules/uploadList/uploadList.module';
import { sendXray } from 'reactApp/utils/ga';
import { put } from 'redux-saga/effects';

export function* handleGlobalFileSizeLimitError(descriptor: UploadingDescriptor) {
    const descriptorId = descriptor.id;
    const cloudPath = descriptor.cloudPath;

    sendXray(['big-file-dialog', 'skip-100-gb']);
    descriptor.failPaused();
    yield put(
        updateUploadFilesAction({
            descriptorId,
            cloudPath,
            status: EFileStatus.ERROR,
            error: EFileError.GLOBAL_FILE_SIZE_LIMIT_ERROR,
        })
    );
    return ERetryErrorFileOptions.cancel;
}
